"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.cDefaultReportDefinition = exports.cGroupByKeyOpts = exports.cGroupByKey = exports.rollingRangeDateUnitOpts = exports.cDateFilterOperatorOptions = exports.cDisplayModes = exports.cSortOptions = exports.cUnavailableDateGroupsByStatistics = exports.cGroupByDateObj = exports.cGroupByDateOpts = exports.cKeyGroup = exports.cGraphTypes = exports.cGraphType = exports.cFilterableDataTypes = exports.cAvailableDataTypesPerStat = exports.cStatisticTypeHasDate = exports.cGroupByDataTypeOpts = exports.cStatDataType = exports.cEngagementDisplayModes = void 0;
var insights_1 = require("../../insights");
var zod_1 = require("zod");
var Dates = __importStar(require("../../dates"));
exports.cEngagementDisplayModes = {
    perAllUsersByActionCount: 'perAllUsersByActionCount',
    perAllUsers: 'perAllUsers',
    perOneUser: 'perOneUser',
    perOneUserList: 'perOneUserList',
    topPerformers: 'topPerformers',
    everything: 'everything',
    perAllUserLists: 'perAllUserLists',
    perAllActions: 'perAllActions',
    perOneAction: 'perOneAction'
};
exports.cStatDataType = {
    // communicationWordCount: 'communicationWordCount', // to be implemented later
    statistic: 'statistic',
    actionType: 'actionType',
    user: 'user',
    memberId: 'memberId',
    date: 'date',
    concept: 'concept',
    userList: 'userList',
    entity: 'entity',
    page: 'page',
    sessionDuration: 'sessionDuration',
    userSearchTerm: 'userSearchTerm',
    connectionState: 'connectionState',
    link: 'link',
    entitySearchTerm: 'entitySearchTerm',
    searchFilter: 'searchFilter',
    applicationState: 'applicationState',
    communicationAuthor: 'communicationAuthor',
    numberOfActionsInSession: 'numberOfActionsInSession',
    reportedBy: 'reportedBy',
    blockId: 'blockId',
    iframeUrl: 'iframeUrl',
    dialogBlockId: 'dialogBlockId'
};
exports.cGroupByDataTypeOpts = [
    // cStatDataType.communicationWordCount,
    exports.cStatDataType.statistic,
    exports.cStatDataType.actionType,
    exports.cStatDataType.blockId,
    exports.cStatDataType.user,
    exports.cStatDataType.memberId,
    exports.cStatDataType.userList,
    exports.cStatDataType.link,
    exports.cStatDataType.entity,
    exports.cStatDataType.page,
    exports.cStatDataType.sessionDuration,
    exports.cStatDataType.userSearchTerm,
    exports.cStatDataType.connectionState,
    exports.cStatDataType.entitySearchTerm,
    exports.cStatDataType.searchFilter,
    exports.cStatDataType.applicationState,
    exports.cStatDataType.communicationAuthor,
    exports.cStatDataType.dialogBlockId,
    exports.cStatDataType.numberOfActionsInSession,
    exports.cStatDataType.reportedBy,
    exports.cStatDataType.iframeUrl
];
/** Not all statistics have a date. */
exports.cStatisticTypeHasDate = (_a = {},
    _a[insights_1.availableStats.logins] = true,
    _a[insights_1.availableStats.userProfileEdits] = true,
    _a[insights_1.availableStats.entityInSearchResults] = true,
    _a[insights_1.availableStats.userProfilePageViews] = true,
    _a[insights_1.availableStats.userSearches] = true,
    _a[insights_1.availableStats.profileSearch] = true,
    _a[insights_1.availableStats.users] = false,
    _a[insights_1.availableStats.acceptedRegistrationsAuto] = true,
    _a[insights_1.availableStats.acceptedRegistrationsManual] = true,
    _a[insights_1.availableStats.acceptedRegistrationsInvitation] = true,
    _a[insights_1.availableStats.acceptedRegistrationsApi] = true,
    _a[insights_1.availableStats.appliedRegistrations] = true,
    _a[insights_1.availableStats.rejectedRegistrations] = true,
    _a[insights_1.availableStats.inProgressRegistrations] = false,
    _a[insights_1.availableStats.canceledRegistrations] = false,
    _a[insights_1.availableStats.suspendedRegistrations] = false,
    _a[insights_1.availableStats.chatMessages] = true,
    _a[insights_1.availableStats.posts] = true,
    _a[insights_1.availableStats.comments] = true,
    _a[insights_1.availableStats.entityViews] = true,
    _a[insights_1.availableStats.entityClicks] = true,
    _a[insights_1.availableStats.entitySearch] = true,
    _a[insights_1.availableStats.searchFilters] = true,
    // [availableStats.sessions]: true,
    _a[insights_1.availableStats.connectionsCreated] = true,
    _a[insights_1.availableStats.applicationsOverTime] = true,
    _a[insights_1.availableStats.currentApplications] = false,
    _a[insights_1.availableStats.reportedPosts] = true,
    // [availableStats.favouritedEntities]: true,
    _a[insights_1.availableStats.pageViews] = true,
    _a[insights_1.availableStats.activityFeed] = true,
    _a[insights_1.availableStats.chatMessageRead] = true,
    _a[insights_1.availableStats.externalLinkClicks] = true,
    _a[insights_1.availableStats.modalsOpened] = true,
    _a[insights_1.availableStats.videoChatCallAccepted] = true,
    _a[insights_1.availableStats.videoChatCallMade] = true,
    _a[insights_1.availableStats.videoChatCallRejected] = true,
    _a[insights_1.availableStats.iframeLoaded] = true,
    _a[insights_1.availableStats.externalInteractions_attendedExclWalkIns] = true,
    _a[insights_1.availableStats.externalInteractions_attendedWalkIn] = true,
    // [availableStats.externalInteractions_noShow]: true,
    _a[insights_1.availableStats.externalInteractions_RSVPedAccepted] = true,
    _a[insights_1.availableStats.externalInteractions_RSVPedDeclined] = true,
    _a[insights_1.availableStats.externalInteractions_RSVPedTentative] = true,
    _a[insights_1.availableStats.externalInteractions_invited] = true,
    _a[insights_1.availableStats.externalInteractions_attendedToInvitedRatio] = true,
    _a[insights_1.availableStats.externalInteractions_rsvpToInvitedRatio] = true,
    _a);
/** This determines what groups and filters are available for a given statistic. */
exports.cAvailableDataTypesPerStat = (_b = {},
    _b[insights_1.availableStats.logins] = ['user', 'userList'],
    _b[insights_1.availableStats.userProfileEdits] = ['user', 'userList'],
    _b[insights_1.availableStats.entityInSearchResults] = ['user', 'userList', 'entity'],
    _b[insights_1.availableStats.userSearches] = ['user', 'userList'],
    _b[insights_1.availableStats.userProfilePageViews] = ['user', 'userList'],
    _b[insights_1.availableStats.users] = ['user', 'userList'],
    _b[insights_1.availableStats.profileSearch] = ['user', 'userList', 'userSearchTerm'],
    _b[insights_1.availableStats.acceptedRegistrationsAuto] = ['memberId'],
    _b[insights_1.availableStats.acceptedRegistrationsManual] = ['memberId'],
    _b[insights_1.availableStats.acceptedRegistrationsInvitation] = ['memberId'],
    _b[insights_1.availableStats.acceptedRegistrationsApi] = ['memberId'],
    _b[insights_1.availableStats.appliedRegistrations] = ['memberId'],
    _b[insights_1.availableStats.rejectedRegistrations] = ['memberId'],
    _b[insights_1.availableStats.inProgressRegistrations] = ['memberId'],
    _b[insights_1.availableStats.canceledRegistrations] = ['memberId'],
    _b[insights_1.availableStats.suspendedRegistrations] = ['memberId'],
    _b[insights_1.availableStats.chatMessages] = ['user', 'userList' /** 'communicationWordCount' */],
    _b[insights_1.availableStats.posts] = ['user', 'userList' /** 'communicationWordCount' */],
    _b[insights_1.availableStats.comments] = ['user', 'userList' /* 'communicationWordCount' */],
    _b[insights_1.availableStats.entityViews] = ['user', 'userList', 'entity'],
    _b[insights_1.availableStats.entityClicks] = ['user', 'userList', 'entity'],
    _b[insights_1.availableStats.entitySearch] = ['user', 'userList', 'entitySearchTerm'],
    _b[insights_1.availableStats.searchFilters] = ['user', 'userList', 'searchFilter'],
    // [availableStats.sessions]: [
    // 	'user',
    //  'userList',
    // 	'sessionDuration',
    // 	'numberOfActionsInSession'
    // ],
    _b[insights_1.availableStats.connectionsCreated] = [
        'user',
        'userList',
        'connectionState'
    ],
    _b[insights_1.availableStats.applicationsOverTime] = ['user', 'userList'],
    _b[insights_1.availableStats.currentApplications] = [
        'user',
        'userList',
        'applicationState'
    ],
    _b[insights_1.availableStats.reportedPosts] = [
        'user',
        'userList',
        'reportedBy',
        'communicationAuthor'
    ],
    // [availableStats.favouritedEntities]: ['user', 'userList', 'entity'],
    _b[insights_1.availableStats.pageViews] = ['user', 'userList', 'page'],
    _b[insights_1.availableStats.activityFeed] = ['user', 'userList'],
    _b[insights_1.availableStats.chatMessageRead] = ['user', 'userList'], // should have two users
    _b[insights_1.availableStats.externalLinkClicks] = [
        'user',
        'userList',
        'link',
        'blockId'
    ], // should have link and context
    _b[insights_1.availableStats.modalsOpened] = [
        'user',
        'userList',
        'dialogBlockId',
        'blockId'
    ],
    _b[insights_1.availableStats.videoChatCallAccepted] = ['user', 'userList'],
    _b[insights_1.availableStats.videoChatCallMade] = ['user', 'userList'],
    _b[insights_1.availableStats.videoChatCallRejected] = ['user', 'userList'],
    _b[insights_1.availableStats.iframeLoaded] = [
        'blockId',
        'entity',
        'user',
        'userList',
        'iframeUrl',
        'page'
    ],
    _b[insights_1.availableStats.externalInteractions_attendedExclWalkIns] = [
        'user',
        'userList',
        'entity'
    ],
    _b[insights_1.availableStats.externalInteractions_attendedWalkIn] = [
        'user',
        'userList',
        'entity'
    ],
    _b[insights_1.availableStats.externalInteractions_RSVPedAccepted] = [
        'user',
        'userList',
        'entity'
    ],
    _b[insights_1.availableStats.externalInteractions_RSVPedTentative] = [
        'user',
        'userList',
        'entity'
    ],
    _b[insights_1.availableStats.externalInteractions_RSVPedDeclined] = [
        'user',
        'userList',
        'entity'
    ],
    _b[insights_1.availableStats.externalInteractions_invited] = [
        'user',
        'userList',
        'entity'
    ],
    _b[insights_1.availableStats.externalInteractions_attendedToInvitedRatio] = [
        'user',
        'userList',
        'entity'
    ],
    _b[insights_1.availableStats.externalInteractions_rsvpToInvitedRatio] = [
        'user',
        'userList',
        'entity'
    ],
    _b);
exports.cFilterableDataTypes = Object.freeze([
    exports.cStatDataType.user,
    exports.cStatDataType.date,
    exports.cStatDataType.userList,
    exports.cStatDataType.concept,
    exports.cStatDataType.entity,
    exports.cStatDataType.applicationState,
    exports.cStatDataType.blockId
]);
exports.cGraphType = {
    line: 'line',
    // area: 'area',
    bar: 'bar'
};
exports.cGraphTypes = [
    exports.cGraphType.line,
    // cGraphType.area,
    exports.cGraphType.bar
];
exports.cKeyGroup = {
    date: 'date',
    dataKey: 'dataKey'
};
// const cGroupByKeyObj = z.enum([cKeyGroup.date, cKeyGroup.dataKey]);
// export type GroupByKey = z.infer<typeof cGroupByKeyObj>;
exports.cGroupByDateOpts = [
    Dates.cDateUnit.day,
    Dates.cDateUnit.week,
    Dates.cDateUnit.month,
    Dates.cDateUnit.year,
    Dates.cDateUnitAdvanced.timeOfDay,
    Dates.cDateUnitAdvanced.dayOfWeek,
    Dates.cDateUnitAdvanced.monthOfYear
];
exports.cGroupByDateObj = zod_1.z.enum(exports.cGroupByDateOpts);
/**
 * Some date groups are unavailable for some statistics.
 */
exports.cUnavailableDateGroupsByStatistics = (_c = {},
    _c[insights_1.availableStats.externalInteractions_attendedToInvitedRatio] = [
        Dates.cDateUnit.day,
        Dates.cDateUnit.week,
        Dates.cDateUnitAdvanced.timeOfDay,
        Dates.cDateUnitAdvanced.dayOfWeek,
        Dates.cDateUnitAdvanced.monthOfYear
    ],
    _c[insights_1.availableStats.externalInteractions_rsvpToInvitedRatio] = [
        Dates.cDateUnit.day,
        Dates.cDateUnit.week,
        Dates.cDateUnitAdvanced.timeOfDay,
        Dates.cDateUnitAdvanced.dayOfWeek,
        Dates.cDateUnitAdvanced.monthOfYear
    ],
    _c);
// Todo - allow sorting by different fields
// const SortField = z.enum(['date', 'total']);
exports.cSortOptions = ['off', 'asc', 'desc'];
exports.cDisplayModes = ['graph', 'table'];
// DATE FILTERS
exports.cDateFilterOperatorOptions = {
    allTimes: 'allTimes',
    rollingRange: 'rollingRange',
    fixedRange: 'fixedRange'
};
exports.rollingRangeDateUnitOpts = [
    Dates.cDateUnitPlural.days,
    Dates.cDateUnitPlural.weeks,
    Dates.cDateUnitPlural.months,
    Dates.cDateUnitPlural.years
];
// ------------------- end of temporarySolution
// GROUP BY && AVERAGE BY
exports.cGroupByKey = {
    date: 'date',
    dataKey: 'dataKey'
};
exports.cGroupByKeyOpts = [exports.cKeyGroup.date, exports.cKeyGroup.dataKey];
exports.cDefaultReportDefinition = {
    title: '',
    opts: {
        stats: [],
        groupBy: {
            groupByKey: exports.cGroupByKey.date,
            groupByValue: Dates.cDateUnit.month
        },
        sort: 'off',
        graphColor: undefined,
        displayMode: 'graph',
        graphType: 'bar',
        graphShouldBeHorizontal: false,
        isEngagementReport: false,
        includeCompound: false,
        doubleSize: false,
        filters: {
            date: {
                operator: 'allTimes'
            }
        }
    }
};
